<!-- bg-grey -->
<div class=" scrollbar dwo">
    <div class="border">
      <div class="table-responsive max-h265"
      infinite-scroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown($event)" >
            <table class="tablest1">
                <thead>
                    <tr>
                        <th style="width: 7%" scope="col" translate>lblWoNo</th>
                        <th style="width: 18%" scope="col" translate>lblRegNumber</th>
                        <th style="width: 15%" scope="col" translate>lblCustomer</th>
                        <th style="width: 25%" scope="col" translate>lblServices</th>
                        <th style="width: 15%" scope="col" translate>lblDate</th>
                        <th style="width: 15%" scope="col" translate>lblDealer</th>
                        <th style="width: 10%" class="text-center" scope="col" translate>lblWoStatus</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="activeWorkOrdersList?.length>0; else load_else">
                        <tr *ngFor="let wo of activeWorkOrdersList; let i=index">
                            <td>
                                <a class="link-primary" (click)="OpenEditView(wo, true)">{{wo.workOrderNumber}}</a>
                            </td>
                            <td>
                                <div class="flmid">
                                    <div class="licplate LPNo d-flex">
                                        <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                        {{wo.licensePlate}}
                                    </div>
                                    <div class="imgWid">
                                        <img af-brand-logo data-type="BRAND" [data-code]="wo.brandCode" class="brandicon" alt="img" />
                                    </div>
                                </div>
                                <div class="mt-1">
                                    <ngb-highlight class="flmid semibold fs-12px lh-16px" [result]="wo.vehicleModel">{{wo.vehicleModel}}
                                    </ngb-highlight>
                                </div>
                            </td>
                            <td>
                                <ngb-highlight [result]="wo.customerFullName">{{wo.customerFullName}}
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="wo.services">{{wo.services}}</ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="wo.appointmentDate | date:'shortDate'" *ngIf="wo.appointmentDate; else notValues">
                                </ngb-highlight>
                                <ng-template #notValues>
                                    <ngb-highlight [result]="">
                                    </ngb-highlight>
                                </ng-template>
                            </td>
                            <td>
                                <ngb-highlight [result]="wo.dealer">{{wo.dealer}}</ngb-highlight>
                            </td>
                            <td>
                                <div class="mx-auto text-center">
                                    <div class="color-box" [ngbTooltip]="wo.workOrderStatus"
                                        tooltipClass="tooltip-inner-width" [style.background-color]="wo.workOrderColor">
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>

</div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg mb-1" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>
